import * as ReactDOMClient from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './layouts/App'
import { HelmetProvider } from '@act/react-helmet-async'
import './i18n'

const container = document.getElementById('root')
const root = ReactDOMClient.createRoot(container)

// Arabic-only shareable URLs: mount the router under /ar so existing routes
// keep working while in-app links preserve the Arabic prefix.
const isArabicPath = window.location.pathname === '/ar' || window.location.pathname.startsWith('/ar/')

root.render(
  <BrowserRouter basename={isArabicPath ? '/ar' : undefined}>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </BrowserRouter>
)
